var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TreeNodes组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import Checkbox from '../Checkbox/Checkbox';

import './Tree.less';

var TreeNodes = function (_Component) {
    _inherits(TreeNodes, _Component);

    function TreeNodes(props) {
        _classCallCheck(this, TreeNodes);

        var _this = _possibleConstructorReturn(this, (TreeNodes.__proto__ || Object.getPrototypeOf(TreeNodes)).call(this, props));

        _this.arrowOnClick = function () {
            _this.setState({ isShowChildren: !_this.state.isShowChildren });
        };

        _this.spanOnClick = function (_ref) {
            var position = _ref.position;

            var selectHandle = _this.props.selectHandle;
            _.isFunction(selectHandle) && selectHandle({ position: position });
        };

        _this.NO_CHECKBOX_PADDING = 30;
        _this.CHECKBOX_PADDING = 49;
        _this.state = {
            isShowChildren: _this.defaultExpand(_this.props),
            isShowSpanTitle: false
        };
        _this.willCheckSpanTitle = false;
        return _this;
    }

    _createClass(TreeNodes, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.defaultExpandAll, this.props.defaultExpandAll) || !_.isEqual(np.defaultExpandedKeys, this.props.defaultExpandedKeys)) {
                this.setState({ isShowChildren: this.defaultExpand(np) });
            }
            if (!_.isEqual(np.rowData.title, this.props.rowData.title)) {
                this.willCheckSpanTitle = true;
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkSpanTitle();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.willCheckSpanTitle) {
                this.checkSpanTitle();
                this.willCheckSpanTitle = false;
            }
        }
    }, {
        key: 'checkSpanTitle',
        value: function checkSpanTitle() {
            if (!this.titleSpan) {
                return;
            }
            if (this.titleSpan.scrollWidth > this.titleSpan.clientWidth) {
                this.setState({ isShowSpanTitle: true });
            } else {
                this.setState({ isShowSpanTitle: false });
            }
        }
    }, {
        key: 'defaultExpand',
        value: function defaultExpand(props) {
            var defaultExpandAll = props.defaultExpandAll,
                defaultExpandedKeys = props.defaultExpandedKeys,
                rowData = props.rowData,
                uniqueKeyName = props.uniqueKeyName;

            return defaultExpandAll || defaultExpandedKeys.indexOf(rowData[uniqueKeyName]) !== -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                rowData = _props.rowData,
                checkable = _props.checkable,
                uniqueKeyName = _props.uniqueKeyName,
                num = _props.num,
                iteratorRow = _props.iteratorRow,
                position = _props.position,
                checkboxHandle = _props.checkboxHandle,
                selectHandle = _props.selectHandle,
                inSelect = _props.inSelect,
                titleCheckbox = _props.titleCheckbox;

            var hasChildren = _.hasIn(rowData, 'children');
            var rowStyle = {
                paddingLeft: !checkable ? this.NO_CHECKBOX_PADDING + num * 20 : this.CHECKBOX_PADDING + num * 20
            };
            var rowCls = classnames({
                'tree-row': true
            });
            var arrowCls = classnames({
                'tree-arrow': true,
                'tree-arrow-checkable': checkable,
                'tree-arrow-none': !hasChildren,
                'tree-arrow-unfold': this.state.isShowChildren
            });
            var titleCls = classnames({
                'tree-title': true
            });
            var titleSpanCls = classnames({
                'tree-title-span': true,
                'tree-title-span-in-select': inSelect,
                'tree-title-active': !titleCheckbox && rowData.selected,
                'overflow-text': true,
                'tree-title-span-disabled': rowData.disabled
            });
            var checkBoxProps = {
                control: true,
                className: 'tree-checkbox',
                checked: rowData.checked,
                disabled: rowData.disabled,
                getValue: function getValue(e) {
                    checkboxHandle({
                        checked: e.checked,
                        position: position
                    });
                    inSelect && selectHandle({ position: position });
                }
            };
            return [React.createElement(
                'div',
                { key: rowData[uniqueKeyName], className: rowCls, style: rowStyle },
                React.createElement(
                    'div',
                    { className: titleCls },
                    React.createElement('i', { className: arrowCls, onClick: this.arrowOnClick }),
                    checkable && React.createElement(Checkbox, checkBoxProps),
                    React.createElement(
                        'span',
                        {
                            className: titleSpanCls,
                            onClick: function onClick() {
                                if (rowData.disabled) {
                                    return;
                                }
                                _this2.spanOnClick({ checked: rowData.checked, position: position });
                            },
                            ref: function ref(el) {
                                _this2.titleSpan = el;
                            },
                            title: this.state.isShowSpanTitle ? rowData.title : null
                        },
                        rowData.title
                    )
                )
            ), hasChildren && this.state.isShowChildren && iteratorRow(rowData.children, num + 1, position)];
        }
    }]);

    return TreeNodes;
}(Component);

TreeNodes.propTypes = {
    uniqueKeyName: PropTypes.string,
    checkable: PropTypes.bool,
    rowData: PropTypes.object,
    num: PropTypes.number,
    iteratorRow: PropTypes.func,
    defaultExpandAll: PropTypes.bool,
    defaultExpandedKeys: PropTypes.array,
    defaultCheckedKeys: PropTypes.array,
    position: PropTypes.array,
    checkboxHandle: PropTypes.func,
    selectHandle: PropTypes.func,
    inSelect: PropTypes.bool,
    titleCheckbox: PropTypes.bool
};
TreeNodes.defaultProps = {};
export default TreeNodes;